export default "__VITE_ASSET__LiqO1Ho___"